import { ctm } from './ctm/theme_ctm';
import { choo } from './choo/theme_choo';
import { islt } from './islt/theme_islt';

export const themes = {
    ctm,
    choo,
    islt,
    // Local is a theme not available on the branding service
    // This helps us test fallbacks to the CTM brand when branding service fails
    local: ctm
};
